import { render, staticRenderFns } from "./LoginRegistrationSuccess.vue?vue&type=template&id=54072844&"
import script from "./LoginRegistrationSuccess.vue?vue&type=script&lang=js&"
export * from "./LoginRegistrationSuccess.vue?vue&type=script&lang=js&"
import style0 from "./LoginRegistrationSuccess.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports